export default "__VITE_ASSET__150c3295__"